/**
 * M2 P7: localStorage-backed save store. Thin IO wrapper around sim-core's pure
 * serialize/deserialize. All access is try-guarded so private-mode / quota
 * failures degrade to "no save" rather than crashing the boot path.
 */
import { serializeSave, deserializeSave, type SaveState } from '@blackmarble/sim-core';

const SAVE_KEY = 'blackmarble.save.v1';
/** Legacy key (pre-Black-Marble rename); read once as a one-way migration fallback. */
const LEGACY_SAVE_KEY = 'helios.save.v1';

export const loadGame = (): SaveState | null => {
  try {
    const raw = localStorage.getItem(SAVE_KEY) ?? localStorage.getItem(LEGACY_SAVE_KEY);
    return raw ? deserializeSave(raw) : null;
  } catch {
    return null;
  }
};

export const saveGame = (s: SaveState): void => {
  try {
    localStorage.setItem(SAVE_KEY, serializeSave(s));
  } catch {
    /* quota / private-mode — saving is best-effort */
  }
};

export const clearSave = (): void => {
  try {
    localStorage.removeItem(SAVE_KEY);
  } catch {
    /* ignore */
  }
};
